import React from 'react';
import { useTranslation } from 'react-i18next';

const Competence: React.FC = () => {
  const { t } = useTranslation();

  const scrollToProcessStep = (stepIndex: number) => {
    const processSection = document.getElementById('process');
    if (processSection) {
      processSection.scrollIntoView({ behavior: 'smooth' });
      // After scrolling to process section, scroll to specific step
      setTimeout(() => {
        const stepElement = document.getElementById(`process-step-${stepIndex}`);
        if (stepElement) {
          stepElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 500);
    }
  };

  const competences = [
    {
      title: t('competence.design'),
      description: t('competence.designDesc'),
      icon: '📐',
      stepIndex: 1
    },
    {
      title: t('competence.delivery'),
      description: t('competence.deliveryDesc'),
      icon: '🚚',
      stepIndex: 2
    },
    {
      title: t('competence.commissioning'),
      description: t('competence.commissioningDesc'),
      icon: '⚙️',
      stepIndex: 3
    },
    {
      title: t('competence.service'),
      description: t('competence.serviceDesc'),
      icon: '🔧',
      stepIndex: 4
    }
  ];

  return (
    <section id="competence" className="py-12 steel-bg border-y border-[#2a2a2a]">
      <div className="container-custom">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {competences.map((competence, index) => (
            <div 
              key={index}
              className="text-center group cursor-pointer"
              onClick={() => scrollToProcessStep(competence.stepIndex)}
            >
              <div className="mb-4 relative">
                <div className="w-16 h-16 mx-auto bg-tech-dark rounded-lg flex items-center justify-center text-2xl border border-[#2a2a2a] group-hover:border-accent-green transition-all duration-300">
                  {competence.icon}
                </div>
                {/* Connecting lines */}
                {index < competences.length - 1 && (
                  <div className="hidden lg:block absolute top-8 left-full w-full h-0.5 bg-gradient-to-r from-accent-green/30 to-transparent"></div>
                )}
              </div>
              <h3 className="text-lg font-semibold text-white mb-2 group-hover:text-accent-green transition-colors duration-300">
                {competence.title}
              </h3>
              <p className="text-sm text-gray-400">
                {competence.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Competence;
